import { type Configuration } from './generated'

export const addCredentials = (configuration: Configuration): Configuration => {
  const newConfiguration = configuration
  newConfiguration.baseOptions = {
    ...configuration.baseOptions,
    withCredentials: true,
  }

  return newConfiguration
}
